import { HIT_TYPE, TARGETS, EVENT_NAMES } from 'app-webtech-core/beacon/const';
import { getPlaybackData } from './helpers/getPlaybackData';

// eslint-disable-next-line no-unused-vars
export const msnPlayerLoadingBeacon = (action, prevState, nextState) => ({
  hitType: HIT_TYPE.EVENT,
  targets: TARGETS.MSN,
  eventName: EVENT_NAMES.CHANNEL_CHANGE,
  eventType: 'nonClick',
  ...getPlaybackData(nextState),
});
